import { useState } from 'react'
import { Category } from 'pages/buffet/ProductList/CategorySection'
import { BuffetProductListQuery } from 'graphQL/dinein/generate/operations'

export type BuffetPackageProducts = BuffetProductListQuery['listBuffetPackageProducts']['products']
export type BuffetCategories = BuffetProductListQuery['listCategories']

const categoryInitialValue = { id: 0, nameEn: '', nameTh: '', image: '' }

const useCategory = () => {
  const [categoryList, setCategoryList] = useState<Category[]>([])
  const [selectedCategory, setSelectedCategory] = useState<Category>(categoryInitialValue)
  const [nextCategory, setNextCategory] = useState<Category>(categoryInitialValue)
  const [isShowButtonChangeCategory, setisShowButtonChangeCategory] = useState(true)

  const initiateCategoryState = ({
    originalCategories = [],
    products = [],
    categoryIDParam,
    isResetSelectCategory = false,
  }: {
    originalCategories: BuffetCategories
    products: BuffetPackageProducts
    categoryIDParam?: number
    isResetSelectCategory?: boolean
  }) => {
    const categoryList: Category[] = []
    originalCategories.forEach((category) => {
      products.forEach((product) => {
        if (
          product.categoryID === category.id &&
          product.active &&
          !categoryList.find((categoryTarget) => categoryTarget.id === category.id)
        ) {
          categoryList.push({
            id: category.id,
            nameEn: category.nameEn,
            nameTh: category.nameTh,
            image:
              category.images.length > 0
                ? category.images[0].resizableURL.replace('{width}x{height}', '150x150_fmt-png_fit-outside')
                : '',
          })
        }
      })
    })

    if (isResetSelectCategory) {
      if (categoryList.length > 0) {
        setSelectedCategory(categoryList[0])
        if (categoryList.length > 1) {
          setNextCategory(categoryList[1])
          setisShowButtonChangeCategory(true)
        } else {
          setNextCategory(categoryInitialValue)
          setisShowButtonChangeCategory(false)
        }
      } else {
        setSelectedCategory(categoryInitialValue)
        setNextCategory(categoryInitialValue)
        setisShowButtonChangeCategory(false)
      }
    } else {
      if (categoryList.length > 0 && selectedCategory.id === 0) {
        if (categoryIDParam) {
          setCurrentCategoryByID(categoryIDParam, categoryList)
          if (categoryList.length > 1) {
            const targetCateIndex = categoryList.findIndex((cate) => cate.id === categoryIDParam)
            if (targetCateIndex < categoryList.length - 1) {
              setNextCategory(categoryList[targetCateIndex + 1])
              setisShowButtonChangeCategory(true)
            } else {
              setisShowButtonChangeCategory(false)
            }
          }
        } else {
          setSelectedCategory(categoryList[0])
          if (categoryList.length > 1) {
            setNextCategory(categoryList[1])
            setisShowButtonChangeCategory(true)
          } else {
            setisShowButtonChangeCategory(false)
          }
        }
      }
    }
    setCategoryList(categoryList)
  }

  const handleChangeCategory = (categoryTarget: Category) => {
    setSelectedCategory(categoryTarget)
    const targetIndex = categoryList.findIndex((category) => category.id === categoryTarget.id)
    if (targetIndex !== categoryList.length - 1) {
      setNextCategory(categoryList[targetIndex + 1])
      setisShowButtonChangeCategory(true)
    } else {
      setisShowButtonChangeCategory(false)
    }
  }

  const setCurrentCategoryByID = (categoryID: number, categories: Category[]) => {
    const currentCategory = categories.find((category) => category.id === Number(categoryID))
    if (currentCategory) {
      setSelectedCategory(currentCategory)
      const targetIndex = categories.findIndex((category) => category.id === currentCategory.id)
      if (targetIndex !== categories.length - 1) {
        setNextCategory(categories[targetIndex + 1])
        setisShowButtonChangeCategory(true)
      } else {
        setisShowButtonChangeCategory(false)
      }
    }
  }

  return {
    initiateCategoryState,
    handleChangeCategory,
    categoryList,
    setCategoryList,
    selectedCategory,
    nextCategory,
    isShowButtonChangeCategory,
  }
}

export default useCategory
